<template>
<Dialog header="Mail Taslağı" 
v-model:visible="$store.state.mail.modal_show" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '75vw'}"
:modal="true"
>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>
<template v-if="!loading">




<div class="grid mt-b">




<div class="col-12 md:col-2">İsim</div>	
<div class="col-12 md:col-10">
<InputText   type="text" v-model="item.name" class="w-full p-inputtext-sm mb-4" :class="{'p-invalid':name_error }" />
<small  class="p-error pt-2" v-if="name_error"> Lütfen bu alanı doldurun</small>
</div>

<div class="col-12 md:col-2">Periodik</div>	
<div class="col-12 md:col-10"><InputSwitch v-model="item.is_periodic" @change="periodicStatusChanged"  /></div>

<div class="col-12 md:col-2" v-if="item.is_periodic">Periyod (Gün)</div>	
<div class="col-12 md:col-10" v-if="item.is_periodic"><InputText   type="number" v-model="item.period" class="w-full p-inputtext-sm" /></div>


<div class="col-12 md:col-2">Sonlandır</div>	
<div class="col-12 md:col-10"><Calendar v-model="item.stop_at" @date-select="stopDateSelected"    :showButtonBar="true" class="w-full p-inputtext-sm"  :touchUI="true"  /></div>
</div>


<Accordion :activeIndex="activeIndex" class="mt-4" @tab-open="activetabchanged">
<AccordionTab v-for="(element,index) in item.translations" :header="element.language.name" :key="index" >
<Editor v-model="element.content" 
editorStyle="height: 250px"
>
<template #toolbar>
<span class="ql-formats">
    <select class="ql-header" defaultValue="0">
        <option value="1">Heading</option>
        <option value="2">Subheading</option>
        <option value="0">Normal</option>
    </select>
</span>
<span class="ql-formats">
  <button class="ql-bold"></button>
  <button class="ql-italic"></button>
  <button class="ql-underline"></button>
</span>
 <span class="ql-formats">
    <button class="ql-list" value="ordered" type="button"></button>
    <button class="ql-list" value="bullet" type="button"></button>
    <select class="ql-align">
        <option defaultValue></option>
        <option value="center"></option>
        <option value="right"></option>
        <option value="justify"></option>
    </select>
</span>
 <span class="ql-formats">
    <button class="ql-link" type="button"></button>
</span>


  </template>
</Editor>
</AccordionTab>

</Accordion>








<small  class="p-error pt-2" v-if="has_error"> Lütfen her dil için gerekli alanları doldurun</small>
</template>


<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="close" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting"/>
<Button :label="$store.state.languages.lang_phrases.kaydet" icon="pi pi-check" @click="submit"  class=" p-button-primary p-button-outlined  p-button-sm"  :loading="$store.state.ui.submitting"/>
</template>
</Dialog>
</template>

<script>
export default {

  name: 'MailTemplateModal',

  data () {
    return {
    	content:"",
    	activeIndex:0,
    	item:{
    		name:"",
    		is_periodic:0,
    		period:15,
    		stop_at:"",
    		translations:[]
    	},
    	loading:true,
    	has_error:false,
    	submitting:false,
    	name_error:false,
    	brands:[],
    	languages:[],
    	projects:[],
    	flows:[],
    	inputfields:[],
    	suppliers:[],
    	nonconformities:[],
    	selected_brand:null,
    	selected_project:null,
    	selected_flow:null,
    	selected_inputfield:null,
    	selected_questionlist:null,

    }
  },
  computed:{
  	showmodal()
  	{
  		
  		return this.$store.state.mail.modal_show
  		
  	}
  },
  watch:{
  	showmodal(newval,oldval)
  	{
  		if(newval)
  		{
  			this.getData()
  		}
  	},
  	activeIndex(newval,oldval)
  	{
  		console.log(this.activeIndex)
  	}
  },
  methods:{
  	async getData()
  	{
  		this.loading = await true
  		this.languages = await this.silentApiGet("languages")
  		if(!this.$store.state.mail.mail_template)
  		{
  			for(let item of this.languages)
  			{
  				let element = await {language_id:item.id,content:"",language:item}
  				await this.item.translations.push(element)
  			}
  		}


  		this.loading = await false
  	},
  	close()
  	{
  		this.$store.dispatch('mail/setModalShow',false) 
  	},
  	typing()
  	{
  		this.has_error = false
  	},
  	submit()
  	{
  		if(!this.item.name || this.item.name=="")
  		{
  			this.name_error = true
  			return false
  		}
  		let formdata = new FormData()
  		formdata.append("item",JSON.stringify(this.item))
  		this.submitting = true
  		//return false
  		this.generalSubmission(formdata,"mailtemplate/store",this.afterSubmit)
  	},
  	afterSubmit(response)
  	{
  		console.log(response.data)
     	//this.$store.dispatch('mail/setModalShow',false) 
     	this.submitting = false
     	//this.content = ""
  	},
  	periodicStatusChanged()
  	{

  	},
  	stopDateSelected()
  	{

  	},
  	brandSelected()
  	{
  		this.item.translations[this.activeIndex].content += "[[brand-"+this.selected_brand+"]]"
  		setTimeout(()=>{
  			this.selected_brand = null
  		},100)
  		
  	},
  	projectSelected()
  	{
  		this.item.translations[this.activeIndex].content += "[[project-"+this.selected_project+"]]"
  		setTimeout(()=>{
  			this.selected_project = null
  		},100)
  	},
  	flowSelected()
  	{
  		this.item.translations[this.activeIndex].content += "[[flow-"+this.selected_flow+"]]"
  		setTimeout(()=>{
  			this.selected_flow = null
  		},100)
  	},
  	inputfieldSelected()
  	{
  		this.item.translations[this.activeIndex].content += "[[inputfield-"+this.selected_inputfield+"]]"
  		setTimeout(()=>{
  			this.selected_inputfield = null
  		},100)
  	},
  	activetabchanged(data)
  	{
  		this.activeIndex = data.index
  	}
  }
}
</script>

<style lang="css" scoped>
</style>